export default {"src":"/_next/static/media/Integrity.49d3c2c0.svg","height":47,"width":47,"blurWidth":0,"blurHeight":0};